var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-100 font-body h-screen w-screen flex flex-col print:h-print-screen print:w-print-screen",attrs:{"id":"app"}},[_c('router-view',{staticClass:"flex-1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }